<div [ngStyle]="{ height: height }" class="modal solid open" id="TableViewModal">
  <div (click)="close()" class="miniClose cancel icon-HamburgerAppClose"></div>
  <div class="title" style="padding-top: 2.0625rem; padding-left: 7.5rem">
    {{ title }}
  </div>
  <div class="alarmmodalicon"></div>

  <div class="subtitle">{{ subtitle }}</div>

  <div class="row">
    <!-- rows -->
    @for (key of keys; track key) {
      <div class="table two">
        <!-- only show keys that have data in the values -->
        @if (item[key] !== '' && item[key] != null) {
          <div class="header borderBottom borderRight">
            {{ key.toUpperCase() }}
          </div>
        }
        @if (item[key] !== '' && item[key] != null) {
          <div class="detailtext borderBottom">
            {{ item[key] }}
          </div>
        }
      </div>
    }
  </div>

  <div class="buttons">
    <button (click)="open()" class="notificationbutton" id="TableViewModalButtonTest">
      <div class="plusicon"></div>
      Add Notification
    </button>
    <button class="save" id="TableViewModalButton" mat-dialog-close>OK Thanks</button>
  </div>
</div>
